import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useScreen } from '../../../../../hooks'
import {
  FlatSelect,
  getFlatSelectFormikFieldControlDisabledProps,
} from '../../../../Flat'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import {
  USER_FORM_FIELD_NAME_BUILDING,
  USER_FORM_FIELD_NAME_FLAT,
} from '../../../../User'

import { getFlatFieldApiParams } from './FlatField.utils'

function FlatField(props) {
  const { t } = useTranslation()

  const { values } = useFormikContext()

  const { isMobileScreenSize } = useScreen()

  const apiParams = getFlatFieldApiParams(values[USER_FORM_FIELD_NAME_BUILDING])

  return (
    <FormikField
      {...props}
      withEntityCreationFromSearchValue
      Component={FormFieldSelectNG}
      Select={FlatSelect}
      apiParams={apiParams}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Inhabitant.FlatNumberPlaceholderKey'),
          },
        },
      }}
      disabled={!values[USER_FORM_FIELD_NAME_BUILDING]}
      emptyValue={null}
      fieldComponentProps={{
        info: t('Inhabitant.FlatNumberInfoKey'),
        label: `${t('Inhabitant.FlatNumberLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      getFieldDisabledProps={getFlatSelectFormikFieldControlDisabledProps}
      name={USER_FORM_FIELD_NAME_FLAT}
    />
  )
}

export default FlatField
